// src/ContactModal.js
import React from 'react';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Contact Us</h3>
        <div className="contact-item">
          <span>Email ID:</span>
          <a href="mailto:lets.connect@automachina.tech" className="contact-link">
          lets.connect@automachina.tech
          </a>
        </div>
        <div className="contact-item">
          <span>Whatsapp:</span>
          <a href="https://wa.me/9324066998" className="contact-link" target="_blank" rel="noopener noreferrer">
            +91-9324066998
          </a>
        </div>
        <button onClick={onClose} className="close-button">Close</button>
      </div>
    </div>
  );
};

export default ContactModal;
